import { Injectable, inject } from '@angular/core';
import { SiaHttpService } from '@sia/shared';
import { PortalDocumentApi } from '../apis/portal-document.api';

@Injectable({
  providedIn: 'root',
})
export class PortalDocumentService {
  private portalDocumentApi = inject(PortalDocumentApi);
  private httpService = inject(SiaHttpService);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  getDocument(documentId: string) {
    return this.portalDocumentApi.getDocument(documentId);
  }
  getResourcesUrl(documentId: string): string {
    let apiUrl = this.httpService.getApiUrl();
    return `${apiUrl?.replace('api', 'Resources')}/${documentId}.pdf`;
  }
}
